import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Pagination keeps the current page in the URL and treats it as the source of
 * truth, so it survives anything that does not change the URL — switching tabs
 * included. Resetting local page state alone is not enough: Pagination pushes
 * the URL value straight back. Call this when moving to a view that should
 * start at page 1.
 */
export function useResetPageParam(urlKey = 'page') {
  const [searchParams, setSearchParams] = useSearchParams();

  return useCallback(() => {
    if (!searchParams.has(urlKey)) return;

    const next = new URLSearchParams(searchParams);
    next.delete(urlKey);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, urlKey]);
}
